import { render, staticRenderFns } from "./TitleScore.vue?vue&type=template&id=f272cbf2&"
import script from "./TitleScore.vue?vue&type=script&lang=js&"
export * from "./TitleScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports